import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import type { ComponentProps } from "react";
import Branding from "../branding/branding";

// in-app routes for the legal pages, also rendered by the embedded login box
export const legalPaths = {
  impressum: "/impressum",
  privacy: "/datenschutz",
  terms: "/nutzungsbedingungen",
  anonymization: "/docs/anonymization",
} as const;

const linkClass =
  "text-foreground-pressed underline-offset-2 transition-colors hover:text-foreground hover:underline";

// showLogin adds a link back to the login box — for the standalone legal pages,
// where it would otherwise be a dead end. off inside the login box itself.
export function LegalFooter({
  className,
  showLogin = false,
  ...props
}: ComponentProps<"footer"> & { showLogin?: boolean }) {
  const { t } = useTranslation();
  return (
    <footer
      className={cn("flex flex-col items-center gap-3 text-center", className)}
      {...props}
    >
      <nav className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-sm">
        {showLogin && (
          <a href="/account/login" className={linkClass}>
            {t("footer_login_label")}
          </a>
        )}
        <a href={legalPaths.impressum} className={linkClass}>
          {t("footer_impressum_label")}
        </a>
        <a href={legalPaths.privacy} className={linkClass}>
          {t("footer_privacy_label")}
        </a>
        <a href={legalPaths.terms} className={linkClass}>
          {t("footer_terms_label")}
        </a>
        <a
          href="https://trust.soulbyte.com"
          target="_blank"
          rel="noreferrer"
          className={linkClass}
        >
          {t("footer_trust_center_label")}
        </a>
      </nav>
      <Branding />
    </footer>
  );
}
